//
//  SDKAssetScale.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var AssetScale;
(function (AssetScale) {
    AssetScale["x1"] = "x1";
    AssetScale["x2"] = "x2";
    AssetScale["x3"] = "x3";
    AssetScale["x4"] = "x4";
})(AssetScale || (AssetScale = {}));
